import React from 'react';

import type { IconProps, NewIconProps } from '@atlaskit/icon';
import TextLengthenIcon from '@atlaskit/icon-lab/core/text-lengthen';

const TextBreakIcon = (
	props: Exclude<IconProps, 'glyph' | 'size'> & {
		color?: NewIconProps['color'];
		size?: NewIconProps['size'];
	},
): React.JSX.Element => {
	// eslint-disable-next-line react/jsx-props-no-spreading
	return <TextLengthenIcon {...props} />;
};

export default TextBreakIcon;
